import React from 'react';
// import PurpleWrapper from '../PurpleWrapper/PurpleWrapper'
import Gallery from '../Gallery/Gallery'
import BtnSubmit from '../../../../../Components/Shared/Buttons/BtnSubmit';

const SongListPreview = (props) => {

    return (
        <div className='song-list-preview' >
            <h2>
            {props.title && <span className="title">{props.title}</span> }         
            {props.subTitle && <span className="subTitle">{props.subTitle}</span> }         
            </h2>      
            <Gallery items={props.items} playerSize={87}  />
            {props.text && <><br /><p>{props.text}</p> </>}         
            <div className="btn-wrapper"><BtnSubmit onclick={props.onclick} text={props.buttonText} /></div>
        </div>
    );
};

export default SongListPreview;
